import { createApp, h, ref } from 'vue'
import ElementPlus from 'element-plus'
import AdminRejectReasonDialog from '@/components/AdminRejectReasonDialog.vue'

/**
 * 弹出带预设原因的驳回对话框。取消时 Promise reject 'cancel'。
 * @param {object} options
 * @param {string} [options.title]
 * @param {string} [options.message]
 * @param {string} [options.category] content|image|profile|idcard|withdraw|recharge|partner|refund
 * @param {string} [options.confirmText]
 * @param {string} [options.placeholder]
 * @param {string[]} [options.extraReasons]
 * @param {string} [options.initialReason]
 * @returns {Promise<string>}
 */
export function promptRejectReason(options = {}) {
  const {
    title = '填写驳回原因',
    message = '将通知相关用户。可点击常见原因加入下方。',
    category = 'content',
    confirmText = '确认驳回',
    placeholder = '点击上方常见原因加入，也可自行填写或修改',
    extraReasons = [],
    initialReason = ''
  } = options

  return new Promise((resolve, reject) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    let settled = false
    const finish = (ok, value) => {
      if (settled) return
      settled = true
      setTimeout(() => {
        try {
          app.unmount()
        } catch (e) { /* ignore */ }
        container.remove()
      }, 180)
      if (ok) resolve(value)
      else reject('cancel')
    }

    const visible = ref(true)
    const app = createApp({
      setup() {
        return () => h(AdminRejectReasonDialog, {
          visible: visible.value,
          title,
          message,
          category,
          confirmText,
          placeholder,
          extraReasons,
          initialReason,
          'onUpdate:visible': (v) => {
            visible.value = v
            if (!v) finish(false)
          },
          onCancel: () => finish(false),
          onConfirm: (text) => {
            finish(true, text)
            visible.value = false
          }
        })
      }
    })
    app.use(ElementPlus)
    app.mount(container)
  })
}
